import {
    type Element,
    type SlateEditor,
} from '@udecode/plate';

import { BaseSourceCaptionPlugin } from '../SourceCaptionBasePlugin';
import type { TSourceCaptionElement } from '../types';

export const insertSourceCaption = (
    editor: SlateEditor,
    at: Element
) => {
    const type = editor.getType(BaseSourceCaptionPlugin);

    editor.tf.withoutNormalizing(() => {
        const atPath = editor.api.path(at)!;
        const afterPath = [...atPath.slice(0, -1), atPath[atPath.length - 1] + 1];

        editor.tf.insertNodes<TSourceCaptionElement>({
            type,
            children: [{ text: 'Zde vložte ručně zdroj nebo použijte nástroj Vložit citaci (@).' }],
            align: 'left'
        }, {
            at: afterPath,
            select: true
        });
    });
};
